import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { inspectionService } from '@core/services/inspectionService';
import { Button } from '@shared/components/Button';
import { Select } from '@shared/components/Select';

const ReportPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [format, setFormat] = useState<'PDF' | 'EXCEL'>('PDF');
  const [isGenerating, setIsGenerating] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleGenerate = async () => {
    if (!id) return;
    setIsGenerating(true);
    setError('');

    try {
      const blob = await inspectionService.generateReport(id, format);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `reporte_${id}.${format === 'PDF' ? 'pdf' : 'xlsx'}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      setError((err as Error).message || 'Error al generar el reporte');
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div className="max-w-md mx-auto space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900">Generar Reporte</h1>
        <Button variant="secondary" onClick={() => navigate('/')}>
          Volver
        </Button>
      </div>

      <div className="bg-white rounded-lg shadow p-6 space-y-4">
        <p className="text-sm text-gray-600">
          Genera un reporte en formato PDF o Excel para la inspección.
        </p>

        <Select
          label="Formato"
          value={format}
          onChange={(e) => setFormat(e.target.value as 'PDF' | 'EXCEL')}
          options={[
            { value: 'PDF', label: 'PDF' },
            { value: 'EXCEL', label: 'Excel' },
          ]}
        />

        {error && (
          <div className="rounded-md bg-red-50 p-4">
            <p className="text-sm text-red-800">{error}</p>
          </div>
        )}

        <Button
          onClick={handleGenerate}
          fullWidth
          isLoading={isGenerating}
          disabled={!id}
        >
          {isGenerating ? 'Generando...' : 'Generar Reporte'}
        </Button>

        <p className="text-xs text-gray-500 text-center">
          ID de inspección: {id}
        </p>
      </div>
    </div>
  );
};

export default ReportPage;